import styled from 'styled-components'
import { Button as MuiButton, darken, lighten } from '@material-ui/core'
import theme from '../theme'

const darkenCoefficient = theme.palette.action.hoverOpacity * 10
const lightenCoefficient = 0.95
const disableBackgroundColor = 'rgba(0, 0, 0, 0.12)'

const StyledMuiButton = styled(MuiButton)`
  &.MuiButton-root {
    box-sizing: border-box;
    min-width: 64px;
    max-height: 40px;
    padding: 0.5rem 1rem;
    border-radius: ${(props) =>
      props.rounded
        ? `${theme.shape.borderRadiusRounded}px`
        : `${theme.shape.borderRadius}px`};

    &.Mui-disabled {
      color: rgba(0, 0, 0, 0.26);
    }
  }

  .MuiButton-label {
    font-family: ${theme.typography.fontFamily};
    font-weight: 600;
    text-transform: none;
    font-size: 1rem;
  }

  &.MuiButton-sizeSmall {
    padding: 0.25rem 0.5rem;
    .MuiButton-label {
      font-size: ${theme.typography.pxToRem(14)};
    }
  }

  &:hover {
    transition: 0.2s ease-in;
  }

  &.MuiButton-containedPrimary {
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};
    &:hover,
    &:active {
      background-color: ${darken(
        theme.palette.primary.main,
        darkenCoefficient
      )};
    }
    &.Mui-disabled {
      background-color: ${disableBackgroundColor};
    }
  }

  &.MuiButton-containedSecondary {
    background-color: ${theme.palette.secondary.main};
    color: ${theme.palette.secondary.contrastText};
    &:hover,
    &:active {
      background-color: ${darken(
        theme.palette.secondary.main,
        darkenCoefficient
      )};
    }
    &.Mui-disabled {
      background-color: ${disableBackgroundColor};
    }
  }

  &.MuiButton-outlinedPrimary {
    border-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.main};
    &:hover,
    &:active {
      border-color: ${theme.palette.primary.main};
      background-color: ${lighten(
        theme.palette.primary.main,
        lightenCoefficient
      )};
    }
    &.Mui-disabled {
      border-color: ${disableBackgroundColor};
    }
  }

  &.MuiButton-outlinedSecondary {
    border-color: ${theme.palette.secondary.main};
    color: ${theme.palette.secondary.main};
    &:hover,
    &:active {
      border-color: ${theme.palette.secondary.main};
      background-color: ${lighten(
        theme.palette.secondary.main,
        lightenCoefficient
      )};
    }
    &.Mui-disabled {
      border-color: ${disableBackgroundColor};
    }
  }

  &.MuiButton-textPrimary {
    color: ${theme.palette.primary.main};
    &:hover {
      background-color: ${lighten(
        theme.palette.primary.main,
        lightenCoefficient
      )};
    }
  }

  &.MuiButton-textSecondary {
    color: ${theme.palette.secondary.main};
    &:hover {
      background-color: ${lighten(
        theme.palette.secondary.main,
        lightenCoefficient
      )};
    }
  }
`

export default StyledMuiButton
